import React, { useEffect, useState } from 'react';

const styles = `
  .table-desktop {
    /* Desktop styles are mostly handled by bootstrap, this class is for selection */
  }
  .cards-mobile {
    display: none;
  }
  @media (max-width: 767px) {
    .table-responsive.table-desktop-wrapper {
      display: none;
    }
    .cards-mobile {
      display: block;
    }
    .card-match {
      border: 1px solid #dee2e6;
      border-radius: .375rem;
      padding: 0.5rem 1rem; /* Snížení vertikálního paddingu */
      margin-bottom: 0.75rem;
      background-color: #fff;
    }
    .match-teams {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.05rem; /* Mírné zmenšení písma */
      margin: 0.25rem 0; /* Snížení vertikálního marginu */
    }
    .match-score {
      font-weight: bold;
      font-size: 1.2rem;
      flex-shrink: 0;
      padding: 0 1rem;
    }
    .match-details {
      font-size: 0.85rem;
      color: #6c757d;
      text-align: center;
      margin-bottom: 0.25rem; /* Snížení spodního marginu */
    }
    .team-name {
      flex: 1;
    }
    .team-name.home {
      text-align: left;
    }
    .team-name.away {
      text-align: right;
    }
  }
`;

function Matches({ seasonId, filterTeamId }) {
  const [matches, setMatches] = useState([]);
  const [teams, setTeams] = useState({});
  const [error, setError] = useState(null);
  const [matchFilterTeam, setMatchFilterTeam] = useState(''); // id týmu pro filtraci zápasů

  useEffect(() => {
    if (!seasonId) return;
    fetch(`/api/teams?season_id=${seasonId}`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const teamMap = {};
          data.forEach(t => { teamMap[t.id] = t.name });
          setTeams(teamMap);
          setError(null);
        } else if (data && data.error) {
          setError(data.error);
          setTeams({});
        }
      })
      .catch(e => setError('Chyba při načítání týmů.'));
    fetch(`/api/matches?season_id=${seasonId}`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setMatches(data);
        } else if (data && data.error) {
          setError(data.error);
          setMatches([]);
        }
      })
      .catch(e => setError('Chyba při načítání zápasů.'));
  }, [seasonId]);

  if (error) return <div style={{color:'red'}}>{error}</div>;
  if (!matches || !Array.isArray(matches)) return null;
  if (matches.length === 0) return <div>V této sezóně zatím nejsou žádné zápasy.</div>;

  // --- Seřazení a filtrování zápasů ---
  const sortedMatches = [...matches].sort((a, b) => {
    const dateA = new Date(a.date + (a.time ? 'T' + a.time : 'T00:00'));
    const dateB = new Date(b.date + (b.time ? 'T' + b.time : 'T00:00'));
    return dateA - dateB;
  });
  let filteredMatches = sortedMatches;
  if (filterTeamId) {
    filteredMatches = sortedMatches.filter(m => m.home_team === filterTeamId || m.away_team === filterTeamId);
  } else if (matchFilterTeam) {
    filteredMatches = sortedMatches.filter(m => String(m.home_team) === matchFilterTeam || String(m.away_team) === matchFilterTeam);
  }

  // --- Výběr týmů pro filtr ---
  const teamList = Object.entries(teams).map(([id, name]) => ({id, name}));

  return (
    <div>
      <style>{styles}</style>
      <h2>Zápasy</h2>
      {!filterTeamId && (
        <div className="mb-3">
          <label className="form-label me-2">Filtrovat podle týmu:</label>
          <select
            className="form-select d-inline-block w-auto"
            value={matchFilterTeam}
            onChange={e => setMatchFilterTeam(e.target.value)}
          >
            <option value=''>Všechny týmy</option>
            {teamList.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
      )}

      {/* Desktop Table */}
      <div className="table-responsive table-desktop-wrapper">
        <table className="table table-striped table-hover align-middle bg-white">
          <thead className="table-light">
            <tr>
              <th className="text-center">Datum</th>
              <th className="text-center">Čas</th>
              <th>Domácí</th>
              <th>Hosté</th>
              <th className="text-center">Výsledek</th>
            </tr>
          </thead>
          <tbody>
            {filteredMatches.map(match => (
              <tr key={match.id}>
                <td className="text-center">{match.date ? new Date(match.date).toLocaleDateString('cs-CZ') : '-'}</td>
                <td className="text-center">{match.time ? match.time.slice(0,5) : '-'}</td>
                <td>{teams[match.home_team] || '-'}</td>
                <td>{teams[match.away_team] || '-'}</td>
                <td className="text-center">{
                  match.home_score !== null && match.away_score !== null
                    ? (
                      <>
                        {`${match.home_score}:${match.away_score}`}
                        {match.home_halftime != null && match.away_halftime != null && (
                          <span className="text-muted ms-1" style={{fontSize: '0.85em'}}>
                            {`(${match.home_halftime}:${match.away_halftime})`}
                          </span>
                        )}
                      </>
                    )
                    : '—'
                }</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="cards-mobile">
        {filteredMatches.map(match => (
          <div key={match.id} className="card-match">
            <div className="match-details">
              {match.date ? new Date(match.date).toLocaleDateString('cs-CZ') : ''}
              {match.time ? ` - ${match.time.slice(0,5)}` : ''}
            </div>
            <div className="match-teams">
              <span className="team-name home">{teams[match.home_team] || '-'}</span>
              <span className="match-score">{
                match.home_score !== null && match.away_score !== null
                  ? (
                    <>
                      {`${match.home_score} : ${match.away_score}`}
                      {match.home_halftime != null && match.away_halftime != null && (
                        <span className="text-muted ms-1" style={{fontSize: '0.7em', fontWeight: 'normal'}}>
                          {`(${match.home_halftime}:${match.away_halftime})`}
                        </span>
                      )}
                    </>
                  )
                  : '—'
              }</span>
              <span className="team-name away">{teams[match.away_team] || '-'}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Matches;
